import React from "react";
import styled from "styled-components";
import { Colors } from "../config";
const errorImg = require("../assets/images/sap_error_icon.png");

const SapError = ({
  errorMsg = "Please Update your latest Passport in SAP",
}) => {
  return (
    <ErrorWrapper>
      <Img src={errorImg} alt="error" />
      <TextWrapper>{errorMsg}</TextWrapper>
    </ErrorWrapper>
  );
};

export default SapError;

const ErrorWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  max-width: 50%;
  @media only screen and (max-width: 768px) {
    max-width: 100%;
  }
`;
const TextWrapper = styled.div`
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  font-size: 0.5rem;
  font-weight: 400;
  color: ${Colors.pomegranate};
  padding: 7px 9px;
  display: flex;
  align-items: center;
  display: flex;
  visibility: hidden;
`;

const Img = styled.img`
  cursor: pointer;
  &:hover ~ ${TextWrapper} {
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    font-size: 0.5rem;
    font-weight: 400;
    color: ${Colors.pomegranate};
    padding: 7px 9px;
    display: flex;
    visibility: visible;
    align-items: center;
  }
`;
